import React from 'react';
import styled from 'styled-components';
import Accordion from '../Accordion';

const Section = styled.section`
    min-height: 100vh;
    height: 100vh;
    width: 100vw;
    background-color: ${props => props.theme.text};
    position: relative;
    color: ${(props) => props.theme.body};
    display: flex;
    jsutify-content: center;
    flex-direction: column;
`

const Title = styled.h1`
    font-size: ${(props) => props.theme.fontxxl};
    text-transform: uppercase;
    color: ${(props) => props.theme.body};
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem auto;
    border-bottom: 2px solid ${(props) => props.theme.text};
    width: fit-content;
`

const Container = styled.div`
    width: 75%;
    margin: 2rem auto;
    color: ${(props) => props.theme.body}
    
    display: flex;
    justify-content: space-between;
    align-content: center;
`

const Box = styled.div`

`

const Faq = () => {
    return (
        <Section id="faq">
            <Title>Faq</Title>
            <Container>
                <Box>
                    <Accordion title="WHERE CAN I VIEW MY NFTS?">
                        Once minted or bought simply connect to your OpenSea account to view your NFTs.
                    </Accordion>
                </Box>
                <Box>
                    <Accordion title="WHAT MARKETPLACE WILL JOLLYSHOW BE LISTED ON?">
                        This information would be disclosed in due time.
                    </Accordion>
                </Box>
                <Box>
                    <Accordion title="WHAT DOES THE ROADMAP LOOK LIKE?">
                        Once minted or bought simply connect to your OpenSea account to view your NFTs.
                    </Accordion>
                </Box>
                <Box>
                    <Accordion title="WHO IS THE TEAM BEHIND JOLLYSHOW">
                        Once minted or bought simply connect to your OpenSea account to view your NFTs.
                    </Accordion>
                </Box>
            </Container>
        </Section>
    )
}
export default Faq;